// roles.js
export const ROLES = {
    ADMIN: 'Admin',
    RECRUITER: 'Recruiter'
};
  